import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppMyWayPage } from './app-my-way';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppMyWayPage,
  ],
  imports: [
    IonicPageModule.forChild(AppMyWayPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class AppMyWayPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-my-way/app-my-way.module.ts